
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    excerpt () {
      if (!this.post?.acf?.hide_excerpt_on_page) {
        return this.post.excerpt || false;
      }
      return false;
    },
  },
};
